import core from './modules/core';
import auth from './modules/auth';
import sample from './modules/resource';
import orgnz from './modules/orgnz';
import faq from './modules/faq';
import myschedule from './modules/myschedule';
import set from './modules/set';
import popup from './modules/popup';
import mypage from './modules/mypage';
import dashboard from './modules/dashboard';
import commonPopup from './modules/commonPopup';
import notice from './modules/notice';
import logging from './modules/logging';
import beacon from './modules/beacon';
import notification from './modules/notification';
import eduplan from './modules/eduplan';
import myCstmr from './modules/myCstmr';
import download from './modules/download';
import app from './modules/app';
import eduqr from './modules/eduqr';
import dgnstTstng from './modules/dgnstTstng';
import counsel from './modules/counsel';

import eduApi from './modules/eduApi';
import chatbot from './modules/chatbot';
import bsnPlan2 from './modules/bsnPlan2';

export default {
  call: core.call,
  auth,
  sample,
  orgnz,
  faq,
  myschedule,
  set,
  popup,
  mypage,
  dashboard,
  commonPopup,
  notice,
  logging,
  beacon,
  notification,
  eduplan,
  myCstmr,
  download,
  app,
  eduqr,
  dgnstTstng,
  counsel,
  eduApi,
  chatbot,
  bsnPlan2
}

